/* global gdAlertify */
import React, { useState, useEffect } from "react";
import axiosInstance from "../config/axiosConfig";
import { Grid, _ } from 'gridjs-react';
import 'gridjs/dist/theme/mermaid.css'
import { gridOptions } from "../utils/gridOptions";
import { calculateAge, formatDate } from "../utils/utils";
import GdTable from "./components/GdTable";
import { render } from "@testing-library/react";
import IngresoAuxiliar from "./IngresoAuxiliar";
import VacacionesModal from "./components/VacacionesModal";

const clasificacionMap = {
    0: '',
    1: 'Básico 0',
    2: 'Básico 0-1',
    3: 'Básico 1',
    4: 'Básico 1-2',
    5: 'Básico 2',
    6: 'Básico 2-3',
    7: 'Básico 3',
    8: 'D',
};

const DetalleAuxiliar = ({ isOpen, onClose, details, observaciones, turnos }) => {
    if (!isOpen) return null;
    
    const resolveTurnoNombre = (id) => {
        const t = turnos.find(item => item.id == id);
        return t ? t.nombre : `ID: ${id}`;
    };

    const columns3 = [
        { name: 'fecha', title: 'Fecha', render: (row) => formatDate(row.fecha) },
        { name: 'observacion', title: 'Observación' }
    ];
    
    return (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
            <div className="modal-dialog modal-xl">
                <div className="modal-content shadow-lg border-0">
                    <div className="modal-header bg-dark text-white py-2">
                        <h6 className="modal-title d-flex align-items-center">
                            <i className="bi bi-person-circle me-2"></i>
                            {details?.nombreAuxiliar || 'Detalle del Auxiliar'}
                        </h6>
                        <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
                    </div>
                    
                    <div className="modal-body bg-light rounded-bottom p-3">
                        {details ? (
                            <div className="row g-3">
                                {/* SECCIÓN PRIORITARIA: TURNOS Y OBS */}
                                <div className="col-md-5">
                                    <div className="card h-100 border-0 shadow-sm">
                                        <div className="card-header bg-white border-bottom-0 pb-0 pt-3">
                                            <h6 className="text-primary fw-bold mb-0">
                                                <i className="bi bi-calendar-event me-2"></i>Turnos y Disponibilidad
                                            </h6>
                                        </div>
                                        <div className="card-body">
                                            <div className="mb-3 d-flex flex-wrap gap-1">
                                                {details.turnos && details.turnos.length > 0 ? (
                                                    details.turnos.map((t, i) => (
                                                        <span key={i} className="badge bg-soft-primary border bor   der-primary text-primary fw-normal py-1 px-2" 
                                                              style={{ backgroundColor: '#eef2ff', fontSize: '0.85rem' }}>
                                                            {resolveTurnoNombre(t.turnoID)}
                                                        </span>
                                                    ))
                                                ) : <span className="text-muted small">Sin turnos registrados</span>}
                                            </div>
                                            <div className="p-2 rounded" style={{ backgroundColor: '#fcf8e3', border: '1px solid #faebcc' }}>
                                                <small className="fw-bold d-block text-warning-emphasis">Obs. Turnos:</small>
                                                <p className="small mb-0 text-dark" style={{ lineHeight: '1.2' }}>{details.obsTurnos || 'Sin observaciones de disponibilidad.'}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* SECCIÓN INFO COMPACTA */}
                                <div className="col-md-7">
                                    <div className="card h-100 border-0 shadow-sm">
                                        <div className="card-body p-3">
                                            <div className="row g-2">
                                                <div className="col-6 col-sm-4">
                                                    <small className="text-muted d-block">RUT</small>
                                                    <span className="small fw-medium">{details.rut}</span>
                                                </div>
                                                <div className="col-6 col-sm-4">
                                                    <small className="text-muted d-block">Edad</small>
                                                    <span className="small fw-medium">{calculateAge(details.fechaNacimiento)} años</span>
                                                </div>
                                                <div className="col-6 col-sm-4">
                                                    <small className="text-muted d-block">Clasificación</small>
                                                    <span className="badge bg-info-subtle text-info py-0 px-2 border border-info-subtle" style={{ fontSize: '0.75rem' }}>
                                                        {clasificacionMap[details.clasificacionID] || 's/d'}
                                                    </span>
                                                </div>
                                                <div className="col-6 col-md-4">
                                                    <small className="text-muted d-block">Celular</small>
                                                    <span className="small fw-medium">{details.celular}</span>
                                                </div>
                                                <div className="col-6 col-md-4">
                                                    <small className="text-muted d-block">Comuna</small>
                                                    <span className="small fw-medium text-truncate d-block">{details.des_comuna}</span>
                                                </div>
                                                <div className="col-6 col-md-4">
                                                    <small className="text-muted d-block">Fecha Ingreso</small>
                                                    <span className="small fw-medium">{formatDate(details.fechaIngreso)}</span>
                                                </div>
                                                <div className="col-12 mt-1 border-top pt-2">
                                                    <small className="text-muted d-block">Título / Institución</small>
                                                    <span className="small d-block fw-medium">{details.titulo} - <span className="fw-normal">{details.institucion}</span></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* OBSERVACIONES DE HISTORIAL - MÁS COMPACTO */}
                                <div className="col-12">
                                    <div className="card border-0 shadow-sm">
                                        <div className="card-header bg-white py-2 border-bottom-0">
                                            <small className="fw-bold text-secondary">
                                                <i className="bi bi-chat-square-dots me-2"></i>Historial de Observaciones
                                            </small>
                                        </div>
                                        <div className="card-body p-0 px-3 pb-2">
                                            <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                                {observaciones && observaciones.length > 0 ? (
                                                    <GdTable
                                                        columns={columns3}
                                                        data={observaciones}
                                                        defaultItemsPerPage={50}
                                                        itemsPerPageOptions={[50]}
                                                    />
                                                ) : (
                                                    <div className="text-center py-3">
                                                        <small className="text-muted italic">No hay historial de observaciones registrado.</small>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="text-center py-5">
                                <div className="spinner-border text-primary spinner-border-sm" role="status"></div>
                                <div className="small mt-2">Cargando detalles...</div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

function AuxiliarSearch() {
    // Estado para almacenar las opciones de categorización, turnos y clasificación
    const [categorizaciones, setCategorizaciones] = useState([]);
    const [turnos, setTurnos] = useState([]);
    const [clasificaciones, setClasificaciones] = useState([]);
    const [observacionesAuxiliar, setObservacionesAuxiliar] = useState(null);

    // Estado para almacenar los valores de los filtros y la tabla de resultados
    const [fechaInicio, setFechaInicio] = useState("");
    const [tipoturno, setTipoTurno] = useState("3");
    const [fechaFin, setFechaFin] = useState("");
    const [fechaIngreso, setFechaIngreso] = useState("");
    const [sexo, setSexo] = useState({ femenino: false, masculino: false });
    const [selectedClasificaciones, setSelectedClasificaciones] = useState([]);
    const [selectedCategorizaciones, setSelectedCategorizaciones] = useState([]);
    const [selectedTurnos, setSelectedTurnos] = useState([]);
    const [resultados, setResultados] = useState([]);
    const [sinAcuerdo, setSinAcuerdo] = useState(false);

    // Obtener los datos de Categorizaciones y Turnos al cargar el componente
    useEffect(() => {
        async function fetchData() {
            try {
                gdAlertify.showLoader()
                // Aquí se hacen las peticiones para obtener las categorías y los turnos
                const categorizacionesResponse = await axiosInstance.get("/params/categorias");
                const turnosResponse = await axiosInstance.get("/params/turnos");
                const clasificacionesResponse = await axiosInstance.get("/params/clasificaciones");
                let categorias = categorizacionesResponse.data.categorias.filter(cat => cat.id != 5 && cat.id != 4);
                setCategorizaciones(categorias);
                setTurnos(turnosResponse.data.turnos);
                setClasificaciones(clasificacionesResponse.data.clasificaciones);
                gdAlertify.hideLoader()
            } catch (error) {
                console.error("Error al obtener los datos: ", error);
            }
        }

        fetchData();
    }, []);

    // Estados
    const [selectedSexos, setSelectedSexos] = useState([]);

    // Funciones genéricas
    const toggleAll = (items, selectedItems, setSelectedItems) => {
        if (selectedItems.length === items.length) {
            setSelectedItems([]);
        } else {
            setSelectedItems(items.map(item => item.id));
        }
    };

    const toggleItem = (id, selectedItems, setSelectedItems) => {
        if (selectedItems.includes(id)) {
            setSelectedItems(selectedItems.filter(item => item !== id));
        } else {
            setSelectedItems([...selectedItems, id]);
        }
    };

    // Funciones específicas
    const handleAllSexoChange = () => {
        toggleAll([{ id: '1' }, { id: '2' }], selectedSexos, setSelectedSexos);
    };
    const handleSexoChange = (id) => {
        toggleItem(id, selectedSexos, setSelectedSexos);
    };

    const handleAllClasificacionChange = () => {
        toggleAll(clasificaciones, selectedClasificaciones, setSelectedClasificaciones);
    };
    const handleClasificacionChange = (id) => {
        toggleItem(id, selectedClasificaciones, setSelectedClasificaciones);
    };

    const handleAllCategoriaChange = () => {
        toggleAll(categorizaciones, selectedCategorizaciones, setSelectedCategorizaciones);
    };
    const handleCategorizacionChange = (id) => {
        toggleItem(id, selectedCategorizaciones, setSelectedCategorizaciones);
    };

    const handleAllTurnoChange = () => {
        toggleAll(turnos, selectedTurnos, setSelectedTurnos);
    };
    const handleTurnoChange = (id) => {
        toggleItem(id, selectedTurnos, setSelectedTurnos);
    };



    // Función para buscar los resultados con Axios
    const buscarAuxiliares = async () => {

        gdAlertify.showLoader()
        try {
            const params = {
                fechaDisponible: fechaInicio,
                fechaFinAuxiliar: fechaFin,
                fechaIngreso,
                sexo: selectedSexos, // Filtros por sexo
                clasificaciones: selectedClasificaciones,
                categorizaciones: selectedCategorizaciones,
                sinAcuerdo,
                tipoturno,
                categoriaNOTIN: [4,5]
            };
            // Realiza la llamada a la API para obtener los auxiliares
            const response = await axiosInstance.get("/auxiliar/busqueda", { params });

            setResultados(response.data.data); // Almacena los resultados en el estado
            gdAlertify.hideLoader()
        } catch (error) {
            gdAlertify.hideLoader()
            console.error("Error al buscar auxiliares: ", error);
        }
    };

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [detalleAuxiliar, setDetalleAuxiliar] = useState(null);

    const [isVacacionesModalOpen, setIsVacacionesModalOpen] = useState(false);
    const [auxiliarForVacaciones, setAuxiliarForVacaciones] = useState(null);

    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [editAuxiliarId, setEditAuxiliarId] = useState(null);

    const verDetalleAuxiliar = async (idAuxiliar) => {
        setIsModalOpen(true); // Abre el modal
        setDetalleAuxiliar(null); // Limpia los datos previos mientras carga
        setObservacionesAuxiliar(null);

        const params = {
            idAuxiliar: idAuxiliar
        };

        try {
            gdAlertify.showLoader()
            const response = await axiosInstance.get("/auxiliar/busqueda", { params });
            setDetalleAuxiliar(response.data.data[0]);

            const historialResponse = await axiosInstance.get("/auxiliar/historial", { params });
            setObservacionesAuxiliar(historialResponse.data.data.observaciones);
            gdAlertify.hideLoader()
        } catch (error) {
            gdAlertify.hideLoader()
            console.error(error);
            setDetalleAuxiliar({ error: "No se pudo cargar la información" });
        }
    };

    const columns = [
        { 
            name: 'nombre', 
            title: 'Nombre',
            render: (row) => (
                <div className="d-flex align-items-center">
                    {row.nombre}
                    {row.en_vacaciones > 0 && (
                        <span className="badge bg-success ms-2" title="En Vacaciones">
                            <i className="bi bi-calendar-check me-1"></i>
                            Vacaciones (Hoy)
                        </span>
                    )}
                    {row.cruza_vacaciones > 0 && (
                        <span className="badge bg-warning text-dark ms-2" title="Vacaciones Programadas en las Fechas Solicitadas">
                            <i className="bi bi-exclamation-triangle me-1"></i>
                            Cruza Vacaciones
                        </span>
                    )}
                </div>
            )
        },
        { name: 'apellidoPaterno', title: 'Apellido Paterno' },
        { name: 'celular', title: 'Celular' },
        { name: 'fechaIngreso', title: 'Fecha Ingreso', render: (row) => formatDate(row.fechaIngreso) },
        { name: 'clasificacionID', title: 'Clasificación', render: (row) => clasificacionMap[row.clasificacionID], cellClassName: "text-center" },
        { name: 'des_categoria', title: 'Categorización', cellClassName: "text-center" },
        { 
            name: 'turnos', 
            title: 'Turnos Disponibles',
            render: (row) => {
                if (!row.turnos || row.turnos.length === 0) return 'N/A';
                return row.turnos.map(t => {
                    const turno = turnos.find(turno => turno.id === t.turnoID);
                    return turno ? turno.nombre : `ID: ${t.turnoID}`;
                }).join(', ');
            },
            cellClassName: "text-center"
        },
        { 
            name: 'obsTurnos', 
            title: 'Obs. Turnos',
            render: (row) => row.obsTurnos || '-',
            cellClassName: "text-center"
        },
        {
            name: 'id',
            title: 'Acción',
            render: (row) => {
                return (
                    <div className="d-flex gap-2">
                        <button
                            className="btn btn-primary btn-sm"
                            onClick={() => verDetalleAuxiliar(row.id)}
                        >
                            Ver Detalle
                        </button>
                        <button
                            className="btn btn-success btn-sm"
                            onClick={() => {
                                setEditAuxiliarId(row.id);
                                setIsEditModalOpen(true);
                            }}
                        >
                            <i className="bi bi-pencil-square me-1"></i> Editar
                        </button>
                        <button
                            className="btn btn-info btn-sm text-white"
                            onClick={() => {
                                setAuxiliarForVacaciones(row);
                                setIsVacacionesModalOpen(true);
                            }}
                        >
                            <i className="bi bi-calendar-check me-1"></i> Vacaciones
                        </button>
                    </div>
                )
            },
        }
    ]

    return (
        <div className="container mt-4">
            <div className="card">
                <div className="card-body">
                    <h3 className="mb-4">Búsqueda de Auxiliar</h3>

                    {/* Filtros de búsqueda */}
                    <div className="row g-3">
                        {/* Filtros por fechas */}
                        <div className="col-md-4">
                            <label className="form-label">Fecha Disponible</label>
                            <input
                                type="date"
                                className="form-control"
                                value={fechaInicio}
                                onChange={(e) => setFechaInicio(e.target.value)}
                            />
                        </div>
                        <div className="col-md-4">
                            <label className="form-label">Hasta (Opcional)</label>
                            <input
                                type="date"
                                className="form-control"
                                value={fechaFin}
                                onChange={(e) => setFechaFin(e.target.value)}
                            />
                        </div>
                        <div className="col-md-4">
                            {fechaInicio && (
                                <>
                                <label className="form-label">Tipo de Turno:</label>
                                <select
                                    className="form-select"
                                    value={tipoturno}
                                    onChange={(e) => setTipoTurno(e.target.value)}
                                >
                                    <option value="3">Día y Noche</option>
                                    <option value="1">Día</option>
                                    <option value="2">Noche</option>
                                </select>
                                </>
                            )}
                        </div>



                        {/* Filtros por sexo */}
                        <div className="col-md-3">
                            <label className="form-label">Sexo</label>
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="allSexo"
                                    checked={selectedSexos.length === 2}
                                    onChange={handleAllSexoChange}
                                />
                                <label className="form-check-label" htmlFor="allSexo">
                                    Seleccionar Todos
                                </label>
                            </div>
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="sexo-2"
                                    checked={selectedSexos.includes('2')}
                                    onChange={() => handleSexoChange('2')}
                                />
                                <label className="form-check-label" htmlFor="sexo-2">
                                    Femenino
                                </label>
                            </div>
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="sexo-1"
                                    checked={selectedSexos.includes('1')}
                                    onChange={() => handleSexoChange('1')}
                                />
                                <label className="form-check-label" htmlFor="sexo-1">
                                    Masculino
                                </label>
                            </div>
                        </div>

                        {/* Filtros por clasificación */}
                        <div className="col-md-3">
                            <label className="form-label">Clasificación</label>
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="allClasificacion"
                                    checked={selectedClasificaciones.length === clasificaciones.length}
                                    onChange={handleAllClasificacionChange}
                                />
                                <label className="form-check-label" htmlFor="allClasificacion">
                                    Seleccionar Todos
                                </label>
                            </div>
                            {clasificaciones.map((clasificacion) => (
                                <div key={clasificacion.id} className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id={`clas-${clasificacion.id}`}
                                        checked={selectedClasificaciones.includes(clasificacion.id)}
                                        onChange={() => handleClasificacionChange(clasificacion.id)}
                                    />
                                    <label className="form-check-label" htmlFor={`clas-${clasificacion.id}`}>
                                        {clasificacion.nombre}
                                    </label>
                                </div>
                            ))}
                        </div>

                        {/* Filtros por categorización */}
                        <div className="col-md-3">
                            <label className="form-label">Categorización</label>
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="allCategoria"
                                    checked={selectedCategorizaciones.length === categorizaciones.length}
                                    onChange={handleAllCategoriaChange}
                                />
                                <label className="form-check-label" htmlFor="allCategoria">
                                    Seleccionar Todos
                                </label>
                            </div>
                            {categorizaciones.map((categorizacion) => (
                                <div key={categorizacion.id} className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id={`cat-${categorizacion.id}`}
                                        checked={selectedCategorizaciones.includes(categorizacion.id)}
                                        onChange={() => handleCategorizacionChange(categorizacion.id)}
                                    />
                                    <label className="form-check-label" htmlFor={`cat-${categorizacion.id}`}>
                                        {categorizacion.codigo}
                                    </label>
                                </div>
                            ))}
                        </div>
                        <div className="col-md-3">
                            <div className="form-check mt-2">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="sinAcuerdo"
                                    checked={sinAcuerdo}
                                    onChange={(e) => setSinAcuerdo(e.target.checked)}
                                />
                                <label className="form-check-label" htmlFor="sinAcuerdo">
                                    Sin acuerdos
                                </label>
                            </div>
                        </div>

                        <div className="col-md-12 d-flex justify-content-center">
                            <button className="btn btn-primary" onClick={buscarAuxiliares}>
                                Buscar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mt-3">
                <div className="card">
                    <div className="card-body">
                        {/* Tabla de resultados */}
                        <GdTable
                            columns={columns}
                            data={resultados}
                            defaultItemsPerPage={100}
                            itemsPerPageOptions={[5, 10, 25, 50, 100]}
                            initialSort={[0, "asc"]}
                        />
                    </div>
                </div>
            </div>

            {/* Modal */}
            <DetalleAuxiliar
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                details={detalleAuxiliar}
                observaciones={observacionesAuxiliar}
                turnos={turnos}
            />

            <VacacionesModal
                isOpen={isVacacionesModalOpen}
                onClose={() => setIsVacacionesModalOpen(false)}
                auxiliarID={auxiliarForVacaciones?.id}
                nombreAuxiliar={auxiliarForVacaciones ? `${auxiliarForVacaciones.nombre} ${auxiliarForVacaciones.apellidoPaterno}` : ''}
            />

            {/* Modal Editar */}
            {isEditModalOpen && (
                <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
                    <div className="modal-dialog modal-xl">
                        <div className="modal-content shadow-lg border-0">
                            <div className="modal-header bg-dark text-white py-2">
                                <h6 className="modal-title d-flex align-items-center">
                                    <i className="bi bi-pencil-square me-2"></i>
                                    Editar Auxiliar
                                </h6>
                                <button type="button" className="btn-close btn-close-white" onClick={() => setIsEditModalOpen(false)}></button>
                            </div>
                            <div className="modal-body bg-light overflow-auto p-3" style={{ maxHeight: '85vh' }}>
                                <IngresoAuxiliar 
                                    idAuxiliar={editAuxiliarId} 
                                    onSuccess={() => {
                                        setIsEditModalOpen(false);
                                        buscarAuxiliares();
                                    }} 
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
}

export default AuxiliarSearch;
